import React, { Component } from "react";
import "./../css/LoggedIn.scss";
import AlexaLogoDark from "./../assets/alexa_logo_horizontal.svg";
import AlexaLogoLight from "./../assets/img_light_theme/alexa_logo_horizontal.svg";
import { ThemeContext, themes } from "./../theme-context";

class HomeLoggedInHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  onClickAlexaLogo = (e) => {
    var win = window.open("https://alexa.amazon.com", "_blank");
    win.focus();
  };

  render() {
    let theme = this.context;
    let AlexaLogo = theme === themes.light ? AlexaLogoLight : AlexaLogoDark;
    return (
      <div className="alexa-logged-header" style={{ margin: "20px 0" }}>
        <img src={AlexaLogo} onClick={this.onClickAlexaLogo} />
      </div>
    );
  }
}
HomeLoggedInHeader.contextType = ThemeContext;
export default HomeLoggedInHeader;
